"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <div class="swiftref-tooltip"></div>
`;
